import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/igold-transactions")({
  staticData: { breadcrumb: { label: "sidebar.production" } },
  component: () => <Outlet />,
});
